/* eslint-disable import/prefer-default-export */
/**
 * Shown both when the API rejects a sign-in from an account that cannot use this
 * app at all, and when a signed-in user asks for a page their role does not
 * carry. Deliberately says nothing about which page or which role.
 */
export const NO_PERMISSION_MESSAGE =
  'Your account does not have permission to access this application';
